import { useEffect,useState } from "react"
import axios from "axios"
import uuid from "react-uuid"
import { parse } from "date-fns"
export default function AddProyecto({clientes,centros,setProyectos}){
    const [error,setError]=useState(false)
    const [acierto,setAcierto]=useState(false)
    const [nombre,setNombre]=useState("")
    const [id_cliente,setIdCliente]=useState(clientes.filter(cliente=>centros.find(centro=>centro.id_cliente==cliente.id)!=null)[0].id)
    const [id_centro,setIdCentro]=useState(centros[0].id)
    const [descripcion,setDescripcion]=useState("")
    const [mensaje,setMensaje]=useState("")
    useEffect(()=>{
        
    },[])
    function getFechaLocal() {
        const fecha = new Date();
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        const hora = String(fecha.getHours()).padStart(2, '0');
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const segundos = String(fecha.getSeconds()).padStart(2, '0');
        return `${anio}-${mes}-${dia}T${hora}:${minutos}:${segundos}`;
    }
    function formatStringReverse(str){
        const d=new Date(str)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        const hora=d.getHours()
        const min=d.getMinutes()
        const sec=d.getSeconds()
        return `${año}/${mes}/${dia} ${hora}:${min}:${sec}`
    }
    const Click=()=>{
        const nuevo={
            id:uuid(),
            nombre:nombre,
            id_centro:id_centro,
            descripcion:descripcion,
            inicio:getFechaLocal(),
            fin:null,
            abierto:true
        }
        let data=[]
        axios.get("https://www.asinova.es/webapi/api/Proyectos/abierto-cerrado")
            .then(res=>{
                data=res.data
                if (data.find(x=>x.nombre==nombre)!=null || nombre.replaceAll(" ","").length==0 || descripcion.replaceAll(" ","").length==0){
                    setError(true)
                    if (data.find(x=>x.nombre==nombre)!=null){
                        setMensaje("Proyecto ya existente")
                    }
                    if (nombre.replaceAll(" ","").length==0){
                        setMensaje("Falta el Nombre")
                    }
                    if (descripcion.replaceAll(" ","").length==0){
                        setMensaje("Falta la Descripción")
                    }
                }
                else{
                    axios.post("https://www.asinova.es/webapi/api/Proyectos",nuevo).then(()=>{
                        data.push(nuevo);
                        setProyectos(data.sort((x,y)=>formatStringReverse(y.inicio).localeCompare(formatStringReverse(x.inicio))));
                        setAcierto(true)})
                }
            })
    }
    const onChange=(event)=>{
        setAcierto(false)
        if (event.target.name=="nombre"){
            setNombre(event.target.value)
        }
        else if (event.target.name=="descripcion"){
            setDescripcion(event.target.value)
        }
    }
    return (
        <div>
            <h1 style={{textAlign:'center'}}>AÑADIR PROYECTO</h1>
            <div className="formulario-vertical"  style={error || acierto?null:{marginBottom:'1rem'}}>
                <select name="cliente" id="cliente" onChange={(e)=>{setIdCliente(e.target.value);setIdCentro(centros.find(x=>x.id_cliente==e.target.value).id)}}>
                    {
                        clientes.filter(cliente=>centros.find(centro=>centro.id_cliente==cliente.id)!=null).map((x)=>(
                            <option value={x.id}>{x.nombre}</option>
                        ))
                    }
                </select>
                <select name="centro" id="centro" value={id_centro} onChange={(e)=>{setIdCentro(e.target.value)}}>
                    {
                        centros.filter(x=>x.id_cliente==id_cliente).map((x)=>(
                            <option value={x.id}>{x.nombre}</option>
                        ))
                    }
                </select>
                <input type="text" name="nombre" id="nombre" placeholder="Nombre" onChange={onChange}/>
                <input type="text" name="descripcion" id="descripcion" placeholder="Descripción" onChange={onChange}/>
            </div>
            {error?<p className='mensaje-error'><b>ERROR: {mensaje}</b></p>:acierto?<p className="aqua" style={{textAlign:'center'}}><b>Proyecto añadido con éxito</b></p>:null}
            <a className='btn-form' style={{margin:'0 auto',width:'fit-content',display:'block'}} onClick={Click}>Enviar</a>
        </div>
    )
}